import { FiltersValue } from '../components/Filters';

const MAX_NAME_LENGTH = 80;

export function buildFolderNameFromFilters(filters: FiltersValue): string {
	if (filters.rs.length > 0) {
		return truncateName(`RS ${filters.rs.join(', ')}`);
	}

	if (filters.items.length > 0) {
		return truncateName(filters.items.map((item) => item.label).join(', '));
	}

	return 'Dostupnost';
}

function truncateName(name: string): string {
	if (name.length <= MAX_NAME_LENGTH) {
		return name;
	}

	return `${name.slice(0, MAX_NAME_LENGTH - 3).trimEnd()}...`;
}
